import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';
import withScreenWidth from '../../js/utils/withScreenWidth';

import VideoThumbnail from '../video-thumbnail';
import nextSlideIcon from '../../images/icons/icon-next-article.svg';
import previousSlideIcon from '../../images/icons/icon-prev-article.svg';

import './video-slider.scss';

class VideoSlider extends PureComponent {
  /**
   * Set initial props.
   * @type {object}
   */
  static defaultProps = {
    setTriggeredFromClick: null,
    fromLive: false,
  };

  /**
   * Set PropTypes for this component.
   * @type {object}
   */
  static propTypes = {
    videos: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    activeVideo: PropTypes.shape({}).isRequired,
    setActiveVideo: PropTypes.func.isRequired,
    setTriggeredFromClick: PropTypes.func,
    fromLive: PropTypes.bool,
  };

  state = {
    currentSlide: 0,
  };

  /**
   * Set slide index.
   *
   * @param {Number} slideIndex
   */
  setSlideIndex = (slideIndex) => {
    this.setState({ currentSlide: slideIndex });
  };

  /**
   * Render a video thumbnail.
   *
   * @param {Object} video The video.
   * @param {Number} index Slide index (if there is one).
   */
  renderVideoThumbnail = (video, index) => {
    const {
      activeVideo,
      setActiveVideo,
      setTriggeredFromClick,
      fromLive,
    } = this.props;
    return (
      <VideoThumbnail
        key={video.network_object_id}
        setActiveVideo={setActiveVideo}
        video={video}
        activeVideo={activeVideo}
        setSlideIndex={this.setSlideIndex}
        currentSlideIndex={index}
        setTriggeredFromClick={setTriggeredFromClick}
        fromLive={fromLive}
      />
    );
  };

  /**
   * Render a slide control button.
   *
   * @param {Object} nextSlide The next slide.
   * @param {String} icon The SVG string.
   * @param {String} altText The alternate image text.
   */
  renderControlButton = (nextSlide, icon, altText) => (
    <button
      className="video-slider__control"
      onClick={nextSlide}
      type="button"
    >
      <img
        src={icon}
        alt={altText}
      />
    </button>
  );

  render() {
    const { videos, screenWidth } = this.props;
    const { currentSlide } = this.state;
    const slidesToShow = 768 > screenWidth ? 2 : 4;
    const slidesToScroll = 768 > screenWidth ? 2 : 4;
    const cellSpacing = 768 > screenWidth ? 20 : 36;
    const slideWidth = 768 > screenWidth ? 0.4 : 'auto';

    return (
      <div className="video-slider__wrapper">
        <Carousel
          slidesToShow={slidesToShow}
          slidesToScroll={slidesToScroll}
          cellSpacing={cellSpacing}
          slideWidth={slideWidth}
          slideIndex={currentSlide}
          afterSlide={(index) => this.setSlideIndex(index)}
          dragging
          width="100%"
          renderCenterRightControls={({ nextSlide }) =>
            this.renderControlButton(nextSlide, nextSlideIcon, 'next')}
          renderCenterLeftControls={({ previousSlide }) =>
            this.renderControlButton(previousSlide, previousSlideIcon, 'previous')}
        >
          {videos.map((article, i) => this.renderVideoThumbnail(article, i))}
        </Carousel>
      </div>
    );
  }
}

export default withScreenWidth(VideoSlider);
